import $ from 'jquery';

/* global Splide */
$(function () {
  //----------------------------------------------
  // フッターのスライダーの設定
  //----------------------------------------------
  if ($('.mp-footer-banners').length && typeof Splide !== 'undefined') {
    new Splide('.mp-footer-banners', {
      type: 'loop',
      perPage: 6,
      gap: 10,
      breakpoints: {
        767: { perPage: 3 },
        1023: { perPage: 5 }
      }
    }).mount();
  }
});
